'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var XCircleIcon = require('@narvar/nth-bit-icon-x-circle');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var types = require('../../types.js');
var ControlView = require('../ControlView/ControlView.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var XCircleIcon__default = /*#__PURE__*/_interopDefaultLegacy(XCircleIcon);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const Unsubscribed = ({
  onOptInAgain,
  featureName,
  layout,
  channel,
  notificationPreferencesState,
  narvarProfileUrl
}) => {
  const {
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    preferenceLevel
  } = notificationPreferencesState ?? {};
  const retailerLevel = preferenceLevel === types.PreferenceLevels.RETAILER;
  const {
    notificationCenter
  } = nthHookSettings.useSettings();
  const {
    continueShoppingUrl = ''
  } = notificationCenter ?? {};
  const {
    notificationCenterSmsUnsubscribedMessage,
    notificationCenterSmsSignupAgain,
    notificationCenterSmsContinueShopping,
    notificationCenterEmailUnsubscribedMessage,
    notificationCenterEmailSignupAgain,
    notificationCenterEmailContinueShopping,
    notificationCenterSmsUnsubscribedMessageRetailerLevel,
    notificationCenterEmailUnsubscribedMessageRetailerLevel,
    notificationCenterLineContinueShopping,
    notificationCenterLineSignupAgain,
    notificationCenterLineUnsubscribedMessage,
    notificationCenterLineUnsubscribedMessageRetailerLevel,
    notificationCenterSublimeManageYourPreferences,
    notificationCenterSublimeSignUpForUpdates,
    notificationCenterSublimeUnsubscribeTitle,
    notificationCenterSublimeUnsubscribeText
  } = nthHookTranslations.useTranslations();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const smsUnsubscribedChannelProps = {
    unsubscribedMessage: (retailerLevel ? mustache__default["default"].render(notificationCenterSmsUnsubscribedMessageRetailerLevel || '', {
      retailerName
    }) : notificationCenterSmsUnsubscribedMessage) || '',
    primaryButtonText: notificationCenterSmsSignupAgain || '',
    secondaryButtonText: notificationCenterSmsContinueShopping || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    signUpEvent: nthHookContextAnalytics.NarvarClickSubTypes.SMS_SIGNUP_AGAIN
  };
  const emailUnsubscribedChannelProps = {
    unsubscribedMessage: (retailerLevel ? mustache__default["default"].render(notificationCenterEmailUnsubscribedMessageRetailerLevel || '', {
      retailerName
    }) : notificationCenterEmailUnsubscribedMessage) || '',
    primaryButtonText: notificationCenterEmailSignupAgain || '',
    secondaryButtonText: notificationCenterEmailContinueShopping || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER,
    signUpEvent: nthHookContextAnalytics.NarvarClickSubTypes.EMAIL_SIGNUP_AGAIN
  };
  const lineUnsubscribedChannelProps = {
    unsubscribedMessage: (retailerLevel ? mustache__default["default"].render(notificationCenterLineUnsubscribedMessageRetailerLevel || '', {
      retailerName
    }) : notificationCenterLineUnsubscribedMessage) || '',
    primaryButtonText: notificationCenterLineSignupAgain || '',
    secondaryButtonText: notificationCenterLineContinueShopping || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_LINE_NOTIFICATION_CENTER,
    signUpEvent: nthHookContextAnalytics.NarvarClickSubTypes.LINE_SIGNUP_AGAIN
  };
  const sublimeUnsubscribedChannelProps = {
    unsubscribedMessage: notificationCenterSublimeUnsubscribeTitle ?? '',
    unsubscribedText: notificationCenterSublimeUnsubscribeText ?? '',
    primaryButtonText: notificationCenterSublimeManageYourPreferences ?? '',
    secondaryButtonText: notificationCenterSublimeSignUpForUpdates ?? '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    signUpEvent: nthHookContextAnalytics.NarvarClickSubTypes.EMAIL_SIGNUP_AGAIN
  };
  const unsubscribedChannelProps = {
    [types.Channels.SMS]: smsUnsubscribedChannelProps,
    [types.Channels.HIPAA_SMS]: smsUnsubscribedChannelProps,
    [types.Channels.EMAIL]: emailUnsubscribedChannelProps,
    [types.Channels.HIPAA_EMAIL]: emailUnsubscribedChannelProps,
    [types.Channels.LINE]: lineUnsubscribedChannelProps,
    [types.Channels.SUBLIME]: sublimeUnsubscribedChannelProps
  };
  const unsubscribeChannels = channel === types.Channels.SMS || channel === types.Channels.HIPAA_SMS || channel === types.Channels.EMAIL || channel === types.Channels.HIPAA_EMAIL || channel === types.Channels.LINE || channel === types.Channels.SUBLIME;
  const {
    unsubscribedMessage = '',
    primaryButtonText = '',
    secondaryButtonText = '',
    eventComponent = '',
    signUpEvent = '',
    unsubscribedText = ''
  } = unsubscribeChannels ? unsubscribedChannelProps[channel] : {};
  const handlePrimaryButtonClick = () => {
    if (channel === types.Channels.SUBLIME && narvarProfileUrl) {
      window.open(`${narvarProfileUrl}/login?type=phone`);
      return;
    }
    logEvent({
      clickCategory: signUpEvent,
      clickNotificationIsOptIn: true,
      clickSubType: signUpEvent,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent,
      eventFeature: eventComponent,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: eventComponent
    });
    onOptInAgain();
  };
  const handleSecondaryButtonClick = () => {
    if (channel === types.Channels.SUBLIME) {
      onOptInAgain();
      return;
    }
    if (continueShoppingUrl) {
      logEvent({
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_RETAILER_LINK,
        clickLinkDestinationUrl: continueShoppingUrl,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_RETAILER_LINK,
        clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
        eventComponent,
        eventFeature: eventComponent,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: eventComponent
      });
    }
  };
  const showSecondaryButton = channel === types.Channels.SUBLIME || continueShoppingUrl;
  return /*#__PURE__*/React__default["default"].createElement(ControlView["default"], {
    channel: channel,
    isLandscape: isLandscape,
    featureName: featureName,
    icon: /*#__PURE__*/React__default["default"].createElement(XCircleIcon__default["default"], null),
    heading: unsubscribedMessage,
    text: unsubscribedText,
    primaryButton: {
      text: primaryButtonText,
      onClick: handlePrimaryButtonClick
    },
    secondaryButton: showSecondaryButton ? {
      text: secondaryButtonText,
      link: continueShoppingUrl ?? undefined,
      onClick: handleSecondaryButtonClick
    } : undefined
  });
};
var Unsubscribed$1 = nthHookSettings.withSettingsProvider(nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(Unsubscribed, {
  translationKeys: ['notificationCenterSmsUnsubscribedMessage', 'notificationCenterSmsSignupAgain', 'notificationCenterSmsContinueShopping', 'notificationCenterEmailUnsubscribedMessage', 'notificationCenterEmailSignupAgain', 'notificationCenterEmailContinueShopping', 'notificationCenterSmsUnsubscribedMessageRetailerLevel', 'notificationCenterEmailUnsubscribedMessageRetailerLevel', 'notificationCenterLineContinueShopping', 'notificationCenterLineSignupAgain', 'notificationCenterLineUnsubscribedMessage', 'notificationCenterLineUnsubscribedMessageRetailerLevel', 'notificationCenterSublimeManageYourPreferences', 'notificationCenterSublimeSignUpForUpdates', 'notificationCenterSublimeUnsubscribeTitle', 'notificationCenterSublimeUnsubscribeText']
}), {
  globalSettingsRequested: `retailerName`
}), {
  settingsRequested: `
      notificationCenter {
        continueShoppingUrl
      }
    `
});

exports["default"] = Unsubscribed$1;
